import React, { useEffect, useState } from "react";
import { getCategories, addCategory, updateCategory, deleteCategory } from "../api/api";
import "../styles/Categories.css";

const Categories = () => {
  const [categories, setCategories] = useState([]);
  const [categoryData, setCategoryData] = useState({ id: null, name: "" });
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await getCategories();
      if (Array.isArray(response.data)) {
        setCategories(response.data);
      } else {
        console.error("Unexpected response:", response.data);
        setCategories([]);
      }
    } catch (err) {
      console.error("Error fetching categories:", err);
      setError("Error fetching categories");
    }
  };

  const handleChange = (e) => {
    setCategoryData({ ...categoryData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let response;
      if (categoryData.id) {
        // Update existing category
        response = await updateCategory(categoryData);
        setMessage(response.data.message || "Category updated successfully");
      } else {
        // Add new category
        response = await addCategory(categoryData);
        setMessage(response.data.message || "Category added successfully");
      }
      setCategoryData({ id: null, name: "" });
      fetchCategories();
    } catch (err) {
      console.error("Error submitting category:", err);
      setError("Failed to submit category.");
    }
  };

  const handleEdit = (category) => {
    setCategoryData({ id: category.id, name: category.name });
    setMessage("");
    setError("");
  };

  const handleDelete = async (categoryId) => {
    if (!window.confirm("Are you sure you want to delete this category?")) return;
    try {
      const response = await deleteCategory({ id: categoryId });
      setMessage(response.data.message || "Category deleted successfully");
      fetchCategories();
    } catch (err) {
      console.error("Error deleting category:", err);
      setError("Failed to delete category.");
    }
  };

  return (
    <div className="categories-container">
      <h2>Manage Categories</h2>
      {message && <p className="message">{message}</p>}
      {error && <p className="error">{error}</p>}
      
      <div className="category-form-container">
        <h3>{categoryData.id ? "Edit Category" : "Add Category"}</h3>
        <form onSubmit={handleSubmit} className="category-form">
          <input
            type="text"
            name="name"
            placeholder="Category Name"
            value={categoryData.name}
            onChange={handleChange}
            required
          />
          <button type="submit" className="category-btn">
            {categoryData.id ? "Update Category" : "Add Category"}
          </button>
        </form>
      </div>
      
      <div className="categories-list">
        {categories.length === 0 ? (
          <p>No categories found.</p>
        ) : (
          <ul>
            {categories.map((category) => (
              <li key={category.id}>
                <span>{category.name}</span>
                <div className="category-actions">
                  <button
                    className="category-btn edit-btn"
                    onClick={() => handleEdit(category)}
                  >
                    Edit
                  </button>
                  <button
                    className="category-btn delete-btn"
                    onClick={() => handleDelete(category.id)}
                  >
                    Delete
                  </button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default Categories;
